  import { connect } from "react-redux";

import TransactionDetails from "./transactionDetails";
import { AppState } from "../../core/reducers/rootReducer";
import * as transactionActionTypes from "../../core/actionTypes/transactionActionTypes";
import * as configActions from "../../core/actionTypes/configActionTypes";
import * as paymentSummaryActions from "../../core/actionTypes/paymentSummaryActionTypes";
import { Dispatch } from "react";
import { submitTransactionConsent, submitTransactionConsentReset } from "../../core/actionCreators/transactionDetailsActionCreators";
import { getTransactionDetails, getTax, getUpload } from "../../core/actionCreators/transactionDetailsActionCreators";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { ISubmitPaymentConsent } from "../../constants/commonTypes";
import { getTransactionSummaryConsentReset } from "../../core/actionCreators/paymentSummaryActionCreators";

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    transactionDetails: state.transactionDetails,
    isLoading: state.isLoading[transactionActionTypes.GET_TRANSACTION_DETAILS] || state.isLoading[transactionActionTypes.SUBMIT_TRANSACTION_CONSENT],
    consentResponse: state.transactionDetails.consentResponse,
    errorTransactionDetails: state.error[transactionActionTypes.GET_TRANSACTION_DETAILS],
    errorSubmitConsent: state.error[transactionActionTypes.SUBMIT_TRANSACTION_CONSENT],
    errorTaxDetails: state.error[transactionActionTypes.GET_TAX_DETAILS],
    isAuthenticated: isUserLoggedIn(txnId),
    inAppBackPressed: state.config.inAppBackPressed,
    submittedConsent: state.transactionDetails.submitRequest,
    partnerData: state.auth,
    uploadDetailsResponse: state.upload.uploadDetailsResponse
  };
};


const mapDispatchToProps = (dispatch: Dispatch<transactionActionTypes.TransactionAction | paymentSummaryActions.PaymentAction | configActions.AppBackAction>) => ({
  submitConsent: (request: ISubmitPaymentConsent) => {
    dispatch(submitTransactionConsent(request));
  },
  getTransactionDetails: () => {
    dispatch(getTransactionDetails());
  },
  resetSubmitConsent: () => {
    dispatch(submitTransactionConsentReset());
  },
  resetTransactionSummary: () => {
    dispatch(getTransactionSummaryConsentReset())
  },
  getTaxDetails: () => {
    dispatch(getTax());
  },
  getUploadDetails: () => {
    dispatch(getUpload());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionDetails);
